var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useSegment } from '@ciceksepeti/cs-segment';
import { getCookie, deleteCookie } from '@ciceksepeti/cs-cookie';
import { SegmentEvents } from '@constants/segment';
import Cookies from '@constants/cookies';
var useSegmentEvents = function () {
    var _a = useSegment(), track = _a.track, identify = _a.identify;
    var sendSegmentTrackEvent = useCallback(function (cookieName, eventName) { return __awaiter(void 0, void 0, void 0, function () {
        var cookie, segments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!track || !identify)
                        return [2 /*return*/];
                    cookie = getCookie(cookieName);
                    if (!cookie)
                        return [2 /*return*/];
                    return [4 /*yield*/, identify()];
                case 1:
                    segments = _a.sent();
                    return [4 /*yield*/, track({
                            segments: segments,
                            event: eventName,
                            fields: ['customer_id', 'membership_type'],
                            additionalFields: {
                                platform: 'Manual'
                            }
                        })];
                case 2:
                    _a.sent();
                    deleteCookie(cookieName, { path: '/' });
                    return [2 /*return*/];
            }
        });
    }); }, [track, identify]);
    var signedUpTrackEvent = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendSegmentTrackEvent(Cookies.SEGMENT_SIGNED_UP, SegmentEvents.SIGNED_UP)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [sendSegmentTrackEvent]);
    var signedUpdateTrackEvent = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendSegmentTrackEvent(Cookies.SEGMENT_SIGNED_UPDATE, SegmentEvents.SIGNED_UPDATE)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [sendSegmentTrackEvent]);
    var signedInTrackEvent = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendSegmentTrackEvent(Cookies.SEGMENT_SIGNED_IN, SegmentEvents.SIGNED_IN)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [sendSegmentTrackEvent]);
    return {
        signedUpTrackEvent: signedUpTrackEvent,
        signedUpdateTrackEvent: signedUpdateTrackEvent,
        signedInTrackEvent: signedInTrackEvent
    };
};
export default useSegmentEvents;
